<div class="row justify-content-between" *ngIf="employeeModuleConfig.isActive">
  <div class="overflow-auto hide-scrollbar col-lg">
    <nav
      class="btn-group btn-group-toggle mb-3 w-100"
      attr.aria-label="{{ 'wcag.myWorkMenu' | translate }}"
      role="tablist"
    >
      <button
        class="btn btn-soft-primary text-nowrap"
        [ngClass]="{ active: currentFilter == 'all' }"
        (click)="onChangeFilter(calendarFilters.ALL)"
        type="button"
        role="tab"
        [attr.aria-selected]="currentFilter == 'all' ? 'true' : 'false'"
      >
        {{ 'general.all' | translate }}
      </button>
      <button
        class="btn btn-soft-primary text-nowrap"
        [ngClass]="{ active: currentFilter == calendarFilters.SUPERVISING }"
        (click)="onChangeFilter(calendarFilters.SUPERVISING)"
        type="button"
        role="tab"
        [attr.aria-selected]="currentFilter == 'all' ? 'true' : 'false'"
      >
        {{ 'employeeModule.supervising' | translate }}
      </button>
      <button
        class="btn btn-soft-primary text-nowrap"
        [ngClass]="{ active: currentFilter == calendarFilters.EMPLOYEE }"
        (click)="onChangeFilter(calendarFilters.EMPLOYEE)"
        type="button"
        *ngIf="
          !environment.moduleConfigs.employeeModule.hideEmployeeCalendarFilter
        "
        role="tab"
        [attr.aria-selected]="currentFilter == 'all' ? 'true' : 'false'"
      >
        {{ 'employeeModule.employee' | translate }}
      </button>
      <button
        *ngIf="environment.moduleConfigs.employeeModule.weekCalendarTab"
        class="btn btn-soft-primary text-nowrap"
        [ngClass]="{ active: currentFilter == calendarFilters.WEEK_CALENDAR }"
        (click)="onChangeFilter(calendarFilters.WEEK_CALENDAR)"
        type="button"
        role="tab"
        [attr.aria-selected]="currentFilter == 'all' ? 'true' : 'false'"
      >
        {{ 'employeeModule.weekCalendar' | translate }}
      </button>
    </nav>
  </div>
  <div
    *ngIf="
      currentFilter != calendarFilters.WEEK_CALENDAR &&
      currentFilter != calendarFilters.EMPLOYEE
    "
    class="col-auto mb-2 mb-lg-0"
    id="showDeclined"
  >
    <button
      class="btn btn-ghost-primary"
      type="button"
      (click)="onShowDecline()"
    >
      <span *ngIf="showDecline">
        <span *ngIf="(selectedLanguage$ | async) != 'de'">
          {{ 'myWorkModule.hide' | translate }}
          {{ 'myWorkModule.declined' | translate }}
        </span>
        <span *ngIf="(selectedLanguage$ | async) == 'de'">
          {{ 'myWorkModule.hideRejected' | translate }}
        </span>
      </span>
      <span *ngIf="!showDecline">
        <span *ngIf="(selectedLanguage$ | async) != 'de'">
          {{ 'myWorkModule.show' | translate }}
          {{ 'myWorkModule.declined' | translate }}
        </span>
        <span *ngIf="(selectedLanguage$ | async) == 'de'">
          {{ 'myWorkModule.showRejected' | translate }}
        </span>
      </span>
    </button>
  </div>
  <div
    *ngIf="
      contractIdsWithSupervisor?.length &&
      currentFilter != calendarFilters.WEEK_CALENDAR
    "
    class="col-auto mb-2 mb-lg-0"
    id="calendarCheckedWrap"
  >
    <button
      class="btn btn-primary"
      type="button"
      (click)="onClickCalendarChecked()"
    >
      {{ 'employeeModule.calendarChecked' | translate }}
    </button>
  </div>
  <div *ngIf="currentFilter == calendarFilters.WEEK_CALENDAR" class="col-auto">
    <button
      class="btn btn-primary"
      type="button"
      (click)="onClickSetUnavailability()"
    >
      {{ 'employeeModule.setCalenderBlock' | translate }}
    </button>
  </div>
</div>

<div
  class="select-contract-from"
  [hidden]="
    currentFilter == calendarFilters.SUPERVISING ||
    currentFilter == calendarFilters.WEEK_CALENDAR
  "
>
  <div
    class="mb-4"
    *ngIf="employeeTextConfig$ | async"
    [innerHTML]="employeeTextConfig$ | async"
  ></div>
  <form
    [formGroup]="form"
    #formRef="ngForm"
    *ngIf="
      (contracts$ | async) &&
      (hasEmployeeRole$ | async) &&
      environment.moduleConfigs.employeeModule.showContractDetails
    "
  >
    <div class="row mb-3 justify-content-between">
      <div class="col-lg mb-3 mb-lg-0">
        <div class="mb-4">
          <label id="contractMultipleId" class="form-label">
            {{ 'employeeModule.selectYourContract' | translate }}
          </label>

          <custom-select-multiple
            [ariaLabelledby]="'contractMultipleId'"
            [selectableItems]="
              contracts$
                | async
                | mapToSelectableItemsPipe: 'id' : 'description' : 'simple'
            "
            [clearable]="true"
            [emptyInitValue]="true"
            [disabled]="false"
            [valueBinder]="'id'"
            [loading]="isLoading$ | async"
            (change)="adjustSelectedContracts($event)"
            formControlName="contractIds"
          >
          </custom-select-multiple>
        </div>
      </div>
    </div>
  </form>
</div>

<div
  class="select-contract-from"
  [hidden]="currentFilter != calendarFilters.WEEK_CALENDAR"
>
  <div class="mb-4">
    {{ 'employeeModule.weekCalendarSubText' | translate }}</div
  >
</div>

<div *ngIf="agendaCloseDate?.length > 0 && employeeModuleConfig.isActive">
  <p class="ms-2 mt-0 fw-bold">
    {{ 'employeeModule.agendaCloseDate' | translate }}:
    {{ agendaCloseDate | formatDate: 'd MMM y' | async }}
  </p>
</div>

<div class="d-flex justify-content-center">
  <span
    class="spinner-border spinner-border-md mt-3"
    role="status"
    *ngIf="isLoading$ | async"
    attr.aria-label="{{ 'wcag.loading' | translate }}"
  ></span>
</div>

<div class="mt-3">
  <calendar
    id="mywork-calendar"
    [events]="calendarEvents$ | async"
    [showDecline$]="showDecline$"
    (onChangeDates)="onChangeDates($event)"
    (onClickDate)="onClickDate($event)"
    (onClickEvent)="onEventClicked($event)"
    [currentView$]="currentFilter$.asObservable()"
    [maxDate]="maxDate$ | async"
    [hideHeader]="currentFilter == calendarFilters.WEEK_CALENDAR ? true : false"
    [showOnlyDayName]="
      currentFilter == calendarFilters.WEEK_CALENDAR ? true : false
    "
    (onClickPrevNextToday)="onShowDecline($event)"
    [slotMinTime]="
      currentFilter == calendarFilters.WEEK_CALENDAR ? '00:00:00' : null
    "
    [slotMaxTime]="
      currentFilter == calendarFilters.WEEK_CALENDAR ? '24:00:00' : null
    "
    [isWeekCalendar]="
      currentFilter == calendarFilters.WEEK_CALENDAR ? true : false
    "
  >
  </calendar>
</div>
